import React from 'react';
import { BestOddsMainLogoWrapper, BestOddsMainLogo } from './bestodds.style';

export const BestOddsLogotype = (): JSX.Element => (
    <BestOddsMainLogoWrapper>
        <BestOddsMainLogo />
    </BestOddsMainLogoWrapper>
);
